import { em } from 'polished'
import styled, { css } from 'styled-components'

import SectionWrapper from 'components/SectionWrapper'
import { setBackground } from 'utils/styled/setBackground'

export const SectionWrapperStyled = styled(SectionWrapper)`
  .inner {
    ${p => p.theme.mq.upMd} {
      min-height: ${p => p.theme.blocks.heightBlock560};
    }

    &--png {
      padding-bottom: ${em(270)};
    }
  }

  ${({ isPng, coverUrl }) =>
    !isPng
      ? css`
          background: center/cover no-repeat;
          ${setBackground('jpg', coverUrl, { xs: 560, md: 1280 })}
        `
      : css`
          background: #ffb826 no-repeat right ${em(-50)} bottom ${em(-10)} /
            170% auto;
          ${setBackground('png', coverUrl, { xs: 560, md: 1280 })};

          ${p => p.theme.mq.upMd} {
            background-size: 96% auto;
          }

          ${p => p.theme.mq.upLg} {
            background-size: auto 74%;
          }
        `}
`
